import { render } from "./GridTabActivitati.vue?vue&type=template&id=0e178701&scoped=true&ts=true"
import script from "./GridTabActivitati.vue?vue&type=script&lang=ts"
export * from "./GridTabActivitati.vue?vue&type=script&lang=ts"

import "./GridTabActivitati.vue?vue&type=style&index=0&id=0e178701&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e178701"]])

export default __exports__